import React, { useState } from 'react';
import { Loader } from 'lucide-react';
import { PersonalDetails } from './PersonalDetails';
import { DurationSelector } from './DurationSelector';
import { VoiceSelector } from './VoiceSelector';
import { MusicSelector } from './MusicSelector';
import { audioService } from '../../services/api';
import { VOICE_MODELS, BACKGROUND_MUSIC } from '../../constants/audio';

const AudioGenerator = ({ onGenerated }) => {
  const [name, setName] = useState('');
  const [topic, setTopic] = useState('');
  const [duration, setDuration] = useState('2');
  const [selectedVoiceId, setSelectedVoiceId] = useState(VOICE_MODELS[0].id);
  const [selectedMusicId, setSelectedMusicId] = useState(BACKGROUND_MUSIC[0].id);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    try {
      if (!name.trim() || !topic.trim()) {
        setError('Please fill in all required fields');
        return;
      }

      setLoading(true);
      setError('');

      const data = {
        name: name.trim(),
        topic: topic.trim(),
        duration: parseInt(duration),
        modelId: selectedVoiceId,
        musicId: selectedMusicId
      };

      const result = await audioService.generateAudio(data);
      
      // Check if we have a process_id in the response
      if (!result.process_id) {
        throw new Error('No process ID received from server');
      }
      
      onGenerated(result);
      
    } catch (err) {
      console.error('Generation error:', err);
      setError(err.message || 'Failed to start generation process');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-6 w-full text-gray-100">
      <PersonalDetails
        name={name}
        topic={topic}
        onNameChange={setName}
        onTopicChange={setTopic}
      />

      <DurationSelector
        duration={duration}
        onDurationChange={setDuration}
      />

      <VoiceSelector
        selectedVoiceId={selectedVoiceId}
        onVoiceSelect={setSelectedVoiceId}
      />

      <MusicSelector
        selectedMusicId={selectedMusicId}
        onMusicSelect={setSelectedMusicId}
      />

      <button
        onClick={handleSubmit}
        disabled={loading || !name.trim() || !topic.trim()}
        className={`w-full py-4 rounded-xl font-medium transition-all ${
          loading || !name.trim() || !topic.trim()
            ? 'bg-gray-700 cursor-not-allowed opacity-50'
            : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 transform hover:scale-[1.02] cursor-pointer'
        }`}
      >
        {loading ? (
          <span className="flex items-center justify-center gap-2">
            <Loader className="w-5 h-5 animate-spin" />
            Starting Generation...
          </span>
        ) : (
          'Generate Wellness Guide'
        )}
      </button>

      {error && (
        <div className="p-4 rounded-xl bg-red-500/10 border border-red-500/50 text-red-400">
          {error}
        </div>
      )}
    </div>
  );
};

export default AudioGenerator;